const getTransactionItemImageUrl = transactionItem =>
  (transactionItem?.print_product_configurations?.records ?? [])
    .map(
      config =>
        config?.front_print_file_url ??
        config?.account_card?.front_preview_file_url,
    )
    .find(Boolean) ?? null;

const getTransactionItemLines = (transactionItem, print) => {
  const printItems = transactionItem?.print_items?.records ?? [];
  if (printItems.length) {
    return printItems.map((printItem, index) => ({
      key: `${transactionItem.id}-item-${index}`,
      quantity: printItem?.quantity ?? 1,
      name: printItem?.print_package_item_type_name ?? 'Print Products',
    }));
  }

  const configs = transactionItem?.print_product_configurations?.records ?? [];
  if (configs.length) {
    return configs.map((config, index) => ({
      key: `${transactionItem.id}-config-${index}`,
      quantity: config?.quantity ?? 1,
      name: config?.print_product_configuration?.name ?? 'Print Products',
    }));
  }

  return [
    {
      key: transactionItem?.id ?? print.id,
      quantity: print?.quantity ?? 1,
      name:
        transactionItem?.custom_print_name ||
        transactionItem?.photo_print_size_name ||
        transactionItem?.photo_pricing_name ||
        print?.name ||
        print?.custom_print?.name ||
        'Print Products',
    },
  ];
};

const getTransactionItemGroup = (transactionItem, print) => {
  const lines = getTransactionItemLines(transactionItem, print);
  const packageName =
    transactionItem?.print_package_name ||
    transactionItem?.photo_pricing_name ||
    null;

  return {
    key: transactionItem?.id ?? print.id,
    isPackage: !!transactionItem?.print_package_name || lines.length > 1,
    packageName,
    lines,
  };
};

export const buildRows = prints => {
  const rowsByKey = new Map();

  prints.forEach(print => {
    const key = `${print?.album?.id ?? 'na'}::${print?.account?.id ?? 'na'}`;

    if (!rowsByKey.has(key)) {
      rowsByKey.set(key, {
        key,
        group: print?.album?.name ?? '—',
        customerName: print?.account?.name ?? '—',
        customerEmail:
          print?.account?.email_address ??
          print?.transaction?.email_address ??
          '—',
        customerPhone: print?.account?.phone_number ?? '—',
        imageUrl: null,
        itemGroups: [],
        seenTransactionItems: new Set(),
      });
    }

    const row = rowsByKey.get(key);

    if (!row.imageUrl) {
      row.imageUrl = getTransactionItemImageUrl(print?.transaction_item);
    }

    const transactionItemId = print?.transaction_item?.id;
    if (transactionItemId && row.seenTransactionItems.has(transactionItemId)) {
      return;
    }
    if (transactionItemId) {
      row.seenTransactionItems.add(transactionItemId);
    }

    row.itemGroups.push(
      getTransactionItemGroup(print?.transaction_item, print),
    );
  });

  return Array.from(rowsByKey.values()).sort((a, b) => {
    if (a.group !== b.group) {
      return a.group.localeCompare(b.group);
    }
    return a.customerName.localeCompare(b.customerName);
  });
};
